import React, { useState } from 'react';
import { ChevronRightIcon } from '../icons/ChevronRightIcon';
import { ArrowLeftIcon } from '../icons/ArrowLeftIcon';

const RATIOS = ['16:9', '9:16', '1:1', '4:3'];

export const ProjectSetup = ({ initialData, onSubmit }) => {
    const [name, setName] = useState(initialData.name);
    const [aspectRatio, setAspectRatio] = useState(initialData.aspectRatio || '16:9');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (name.trim()) {
            onSubmit({ name, aspectRatio });
        }
    };

    return (
        <div className="w-full h-full overflow-y-auto p-8">
            <div className="w-full max-w-lg mx-auto">
                <h2 className="text-3xl font-bold text-center mb-2">Create a New Project</h2>
                <p className="text-gray-400 text-center mb-8">Let&apos;s start with the basics for your new project.</p>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="projectName" className="block text-sm font-medium text-gray-300 mb-2">Project Name</label>
                        <input
                            type="text"
                            id="projectName"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="e.g., 'Summer Campaign'"
                            className="w-full p-3 bg-gray-800/50 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 transition-all"
                            data-testid="project-name-input"
                        />
                    </div>
                    <div>
                        <label htmlFor="aspectRatio" className="block text-sm font-medium text-gray-300 mb-2">Aspect Ratio</label>
                        <select id="aspectRatio" value={aspectRatio} onChange={e => setAspectRatio(e.target.value)} className="w-full p-3 bg-gray-800/50 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 transition-all" data-testid="aspect-ratio-select">
                            {RATIOS.map(r => <option key={r} value={r}>{r}</option>)}
                        </select>
                    </div>
                    <button
                        type="submit"
                        disabled={!name.trim()}
                        className="w-full bg-purple-600 hover:bg-purple-700 disabled:bg-gray-600 disabled:cursor-not-allowed text-white font-bold py-3 px-4 rounded-lg transition-colors text-lg"
                    >
                        Continue
                    </button>
                </form>
            </div>
        </div>
    );
};
